import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { applyDesignSystemTheme } from './design-system/theme';
import './index.css';
import './styles/design-system.css';

applyDesignSystemTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60 * 1000, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* ToastProvider is added in Wave 2 (T2.1 primitives). */}
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
